import { useMutation } from '@tanstack/react-query';
import React, { Suspense, lazy, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';
import { FallbackView } from '../../_metronic/partials';
import { MenuTestPage } from '../pages/MenuTestPage';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import ReleaseNotes from '../pages/release-notes';

// import { getOrRegisterServiceWorker, onMessageListener, requestForToken } from '../utils/firebase';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export function PrivateRoutes() {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
  const ChatPage = lazy(() => import('../pages/messages'));
  const ApplicationPage = lazy(() => import('../pages/applications'));
  const UsersPage = lazy(() => import('../pages/users'));
  const TodosPage = lazy(() => import('../pages/todos'));
  const EmailPage = lazy(() => import('../pages/email'));
  const TicketsPage = lazy(() => import('../pages/tickets'));
  const ReleaseNotesPage = lazy(() => import('../pages/release-notes'));

  // Rezervasyon Yönetimi
  const ReservationsPage = lazy(() => import('../pages/reservations'));
  const CheckInOutPage = lazy(() => import('../pages/check-in-out'));
  const RoomCalendarPage = lazy(() => import('../pages/room-calendar'));

  // Oda Yönetimi
  const RoomsPage = lazy(() => import('../pages/rooms'));
  const RoomTypesPage = lazy(() => import('../pages/room-types'));
  const HousekeepingPage = lazy(() => import('../pages/housekeeping'));

  // Misafir Yönetimi
  const GuestsPage = lazy(() => import('../pages/guests'));
  const GuestRequestsPage = lazy(() => import('../pages/guest-requests'));

  // Finans & Muhasebe (Yakında - Pasif)
  // const InvoicesPage = lazy(() => import('../pages/invoices'));
  // const PaymentsPage = lazy(() => import('../pages/payments'));
  // const ExpensesPage = lazy(() => import('../pages/expenses'));
  // const ReportsPage = lazy(() => import('../pages/reports'));

  // Hizmetler (Yakında - Pasif)
  // const RestaurantPage = lazy(() => import('../pages/restaurant'));
  // const SpaPage = lazy(() => import('../pages/spa'));
  // const LaundryPage = lazy(() => import('../pages/laundry'));
  // const MinibarPage = lazy(() => import('../pages/minibar'));

  // Sistem Yönetimi
  const SettingsPage = lazy(() => import('../pages/settings'));
  const FacilitySettingsPage = lazy(() => import('../pages/facility-settings'));

  // Üçüncü Parti Sistemler
  const ChannelManagerPage = lazy(() => import('../pages/channel-manager'));
  const BookingEnginesPage = lazy(() => import('../pages/booking-engines'));
  const PmsIntegrationPage = lazy(() => import('../pages/pms-integration'));
  const AgencyChannelPage = lazy(() => import('../pages/agency-channel'));
  const PaymentGatewaysPage = lazy(() => import('../pages/payment-gateways'));
  const ApiManagementPage = lazy(() => import('../pages/api-management'));
  const CitiesPage = lazy(() => import('../pages/cities'));

  const { user } = useAppSelector((state) => state.auth);

  // onMessageListener()
  //   .then((payload: any) => {
  //     toast.info(
  //       <div className="w-100 d-flex flex-column  justify-content-center h-100 mt-3 ">
  //         {/* insert your icon here */}
  //         <span style={{ fontWeight: 'bold', color: '#000' }}>{payload?.notification?.title}</span>
  //         <p>{payload?.notification?.body}</p>
  //       </div>,
  //       {
  //         autoClose: false,
  //       },
  //     );
  //   })
  //   .catch((err) => {
  //     // ('failed: ', err)
  //   });

  // getOrRegisterServiceWorker();

  const notificationTokenUpdateMutation = useMutation<any, any, any>({
    mutationKey: ['notification-token-update'],
    mutationFn: (params) => {
      return axios.post(REACT_APP_API_URL + '/auth/change-notification-token', { id: user?.id, notification_token: params, company_id: user?.company_id });
    },
    onError: (err) => {
      // toast.error(err.response?.data?.message || 'İşleminizi bilinmeyen bir hatadan ötürü tamamlayamadık.', {
      //   autoClose: 2000,
      // });
    },
    onSuccess: () => {},
  });

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const token = await requestForToken();
  //       notificationTokenUpdateMutation.mutate(token);
  //     } catch (error) {
  //       console.error('Error fetching token: ', error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path="/dashboard" component={DashboardWrapper} />

        {/* Rezervasyon Yönetimi */}
        <Route path="/reservations" component={ReservationsPage} />
        <Route path="/check-in-out" component={CheckInOutPage} />
        <Route path="/room-calendar" component={RoomCalendarPage} />

        {/* Oda Yönetimi */}
        <Route path="/rooms" component={RoomsPage} />
        <Route path="/room-types" component={RoomTypesPage} />
        <Route path="/housekeeping" component={HousekeepingPage} />

        {/* Misafir Yönetimi */}
        <Route path="/guests" component={GuestsPage} />
        <Route path="/guest-requests" component={GuestRequestsPage} />

        {/* Finans & Muhasebe (Yakında - Pasif) */}
        {/* <Route path="/invoices" component={InvoicesPage} /> */}
        {/* <Route path="/payments" component={PaymentsPage} /> */}
        {/* <Route path="/expenses" component={ExpensesPage} /> */}
        {/* <Route path="/reports" component={ReportsPage} /> */}

        {/* Hizmetler (Yakında - Pasif) */}
        {/* <Route path="/restaurant" component={RestaurantPage} /> */}
        {/* <Route path="/spa" component={SpaPage} /> */}
        {/* <Route path="/laundry" component={LaundryPage} /> */}
        {/* <Route path="/minibar" component={MinibarPage} /> */}

        {/* Sistem Yönetimi */}
        <Route path="/settings" component={SettingsPage} />
        <Route path="/facility-settings" component={FacilitySettingsPage} />

        {/* Üçüncü Parti Sistemler */}
        <Route path="/channel-manager" component={ChannelManagerPage} />
        <Route path="/booking-engines" component={BookingEnginesPage} />
        <Route path="/pms-integration" component={PmsIntegrationPage} />
        <Route path="/agency-channel" component={AgencyChannelPage} />
        <Route path="/payment-gateways" component={PaymentGatewaysPage} />
        <Route path="/api-management" component={ApiManagementPage} />
        <Route path="/cities" component={CitiesPage} />

        <Route path="/applications" component={ApplicationPage} />
        <Route path="/users" component={UsersPage} />
        <Route path="/todos" component={TodosPage} />
        <Route path="/account" component={AccountPage} />
        <Route path="/tickets" component={TicketsPage} />
        <Route path="/email" component={EmailPage} />

        {/* <Route path='/crafted/pages/profile' component={ProfilePage} />  */}
        {/* <Route path="/builder" component={BuilderPageWrapper} /> */}
        {/* <Route path="/crafted/pages/wizards" component={WizardsPage} /> */}
        <Route path="/crafted/widgets" component={WidgetsPage} />
        <Route path="/messages" component={ChatPage} />
        {/* <Route path="/menu-test" component={MenuTestPage} /> */}
        <Route path="/release-notes" component={ReleaseNotesPage} />
        <Redirect from="/auth" to="/dashboard" />
        <Redirect exact from="/" to="/dashboard" />
        <Redirect to="error/404" />
      </Switch>
    </Suspense>
  );
}
